'use es6';

import { handleActions } from 'flux-actions';
import * as ActionTypes from 'MeetingsLib/redux/actions/ActionTypes';
export default handleActions({
  [ActionTypes.SET_LEGITIMATE_INTEREST_CONFIRMED]() {
    return true;
  }

}, null);